import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ChevronLeftIcon(props: FixMe) {
  return <ChevronLeft {...props} />;
}

export default ChevronLeftIcon;
